import Vue from 'vue'

Vue.prototype.$http_codes = {
    'success': 200,
    'validation_error': 422,
    'unauthenticated': 401,
    'unauthorized': 403,
    'server_error': 500
}